import React, { useEffect, useState } from 'react';
import { Input, Icon } from 'components';
import { useDebounce, useIsFirstRender } from 'hooks';
import styled from 'styled-components';
import { MLSStaffMenuOptionsType } from 'components/SideMenu/MenuSection/types';
import { useMLSStaffContext } from './MLSStaffContext';

type SearchBarProps = {
  type: MLSStaffMenuOptionsType;
  disabled?: boolean;
};

const menuTypePlaceholderMap: Record<MLSStaffMenuOptionsType, string> = {
  users: 'User, OID, Brokerage Name',
  brokerages: 'Brokerage Name, OID',
  lockboxes: 'Search lockboxes',
  quickAssignment: '',
  modal: 'Search brokerage or OID',
};

const SearchBar: React.FC<SearchBarProps> = ({ type, disabled }) => {
  const isFirstRender = useIsFirstRender();
  const { text, setText, setPage, setModalSearchText, modalVisible } =
    useMLSStaffContext();
  const [localText, setLocalText] = useState(type === 'modal' ? '' : text);
  const debouncedText = useDebounce(localText, 500);

  useEffect(() => {
    if (type === 'modal') {
      setModalSearchText(debouncedText);
    } else {
      setText(debouncedText);
      setPage(0);
    }
  }, [debouncedText]);

  useEffect(() => {
    if (isFirstRender) return;
    setLocalText('');
  }, [type]);

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLocalText(e.target.value);
  };
  return (
    <StyledInput
      $fullWidth={type === 'modal'}
      disabled={disabled}
      allowClear
      placeholder={menuTypePlaceholderMap[type]}
      prefix={<Icon type="search" color="gray7" />}
      value={localText}
      onChange={onChangeHandler}
      data-cy={`mls-staff-${type}-search`}
    />
  );
};

const StyledInput = styled(Input)<{ $fullWidth?: boolean }>`
  width: ${props => (props.$fullWidth ? '100%' : '280px')}
  height: 50px;
  display: flex;
  align-items: center;
  & > span {
    height: 40px;
  }
`;

export default SearchBar;
